/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("FocusChildUIBehavior", ["UIBehaviorBase"], function (context, cls) {
  /**
   * Trigger a CSS class when a child is focused.
   * Usefull for Table, and scrollgrid to avoid using :has CSS selector
   * @class FocusChildUIBehavior
   * @memberOf classes
   * @extends classes.UIBehaviorBase
   */
  cls.FocusChildUIBehavior = context.oo.Singleton(cls.UIBehaviorBase, function ($super) {
    return /** @lends classes.FocusChildUIBehavior.prototype */ {
      /** @type {string} */
      __name: "FocusChildUIBehavior",
      /**
       * @inheritDoc
       */
      _attachWidget: function (controller, data) {
        if (controller?.getWidget()) {
          data.childFocusHandle = controller.when(gbc.constants.controllerEvents.focusChild, this._onFocusChild.bind(this, controller, data));
        }
      },
      /**
       * @inheritDoc
       */
      _detachWidget: function (controller, data) {
        this._destroyUnfocusHandles(data);
        if (data.childFocusHandle) {
          data.childFocusHandle();
          data.childFocusHandle = null;
        }
      },

      /**
       * Creates an action command
       */
      _onFocusChild: function (controller, data, gbcEvent, emitter, childWidget) {
        controller.getWidget().addClasses("gbc_hasFocusedChild");
        data.childLoseFocusHandle = childWidget.when(gbc.constants.widgetEvents.loseFocus, this._onUnFocusChild.bind(this, controller, data));
        data.childDestroyedHandle = childWidget.when(gbc.constants.widgetEvents.destroyed, this._onUnFocusChild.bind(this, controller, data));
      },

      _onUnFocusChild: function (controller, data, gbcEvent) {
        controller.getWidget().removeClass("gbc_hasFocusedChild");
        this._destroyUnfocusHandles(data);
      },

      _destroyUnfocusHandles: function (data) {
        if (data.childLoseFocusHandle) {
          data.childLoseFocusHandle();
          data.childLoseFocusHandle = null;
        }
        if (data.childDestroyedHandle) {
          data.childDestroyedHandle();
          data.childDestroyedHandle = null;
        }
      }
    };
  });
});
